import {useRef} from "@wordpress/element";
import {animate, useMotionValue} from "framer-motion";

export const useSwipe = ({onNext, onPrev, containerRef}) => {
    const x = useMotionValue(0);
    const busy = useRef(false);

    const getWidth = () => containerRef.current?.offsetWidth ?? 300;

    const commit = async (dir) => {
        if (busy.current) return;
        busy.current = true;
        await animate(x, dir === 1 ? -getWidth() : getWidth(), {
            duration: 0.35,
            ease: "easeInOut",
        });
        dir === 1 ? onNext() : onPrev();
        x.set(0);
        busy.current = false;
    };

    const handlePan = (_, {offset}) => {
        if (busy.current) return;
        x.set(offset.x);
    };

    const handlePanEnd = (_, {offset, velocity}) => {
        if (busy.current) return;
        if (Math.abs(offset.x) > getWidth() * 0.35 || Math.abs(velocity.x) > 500) {
            commit(offset.x < 0 ? 1 : -1);
        } else {
            animate(x, 0, {type: "spring", stiffness: 400, damping: 40});
        }
    };

    return {x, commit, handlePan, handlePanEnd};
};